import React from "react";
import { Routes, Route } from "react-router-dom";
import Home from "./home";
import WhyUs from "./Why-Choose-Us/main";
import HereditaryCancerClinic from "./CancerClinic/main";
import Resources from "./Resources/main";
import AboutUsPage from "./AboutUs/main";
import FloatingHomeButton from "./FloatingHomeButton";
import HereditaryCareAI from "./HereditaryCareAI/main";
import { GAListener } from "./Services/GAListener";
function App() {
  return (
    <>
      <GAListener/>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/why-us" element={<WhyUs />} />
        <Route
          path="/hereditary-cancer-clinic"
          element={<HereditaryCancerClinic />}
        />
        <Route path="/resources" element={<Resources />} />
        <Route path="/about-us" element={<AboutUsPage />} />
        <Route path="/cancer-genetics-ai" element={<HereditaryCareAI />} />
      </Routes>

      {/* Home button displayed globally. */}
      <FloatingHomeButton />
    </>
  );
}

export default App;
